import { FC, useState } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { useSnackbar } from 'notistack';
// Components
import { Modal, Button } from '../../../components';
import { Save } from '@mui/icons-material';
import { Divider, Fade, Typography, Grid, TextField, ButtonGroup } from '@mui/material';
import { createUndefinedPart } from '../../../fetch';

interface IUndefinedPartsModal {
  open: boolean;
  onClose: () => void;
  onSave: (val: number) => void;
}

export const UndefinedPartsModal: FC<IUndefinedPartsModal> = ({ open, onClose, onSave }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [newDescription, setNewDescription] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleCreate = async () => {
    let res = 0;
    try {
      setIsSaving(true);
      res = await createUndefinedPart(newDescription);
      enqueueSnackbar('Undefined Part Added!', {
        variant: 'success'
      });
    } catch (error) {
      var errorMessage = error?.response?.data?.Detail;
      enqueueSnackbar(errorMessage ? errorMessage : 'Error adding undefined part, please try again.', {
        variant: 'error'
      });
      console.log(error);
    } finally {
      setNewDescription('');
      onSave(res);
      onClose();
      setIsSaving(false);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          onClose();
        }}
        maxWidth="sm"
      >
        <Fade in={open}>
          <div>
            <Typography variant="h5">Add an Undefined Part Description</Typography>
            <Divider />
            <div className={classes.content}></div>
            <Grid container spacing={1} direction="column">
              <Grid item></Grid>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Enter description..."
                  name="newUndefinedPartDescription"
                  value={newDescription}
                  onKeyDown={e => {
                    if (e.key === 'Enter' && newDescription.length > 0) {
                      handleCreate();
                    }
                  }}
                  onChange={e => {
                    setNewDescription(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} className={classes.saveWrapper}>
                <ButtonGroup>
                  <Button
                    id="save"
                    color="primary"
                    variant="contained"
                    disabled={isSaving || newDescription === ''}
                    loading={isSaving ? 'Saving...' : ''}
                    startIcon={<Save />}
                    onClick={async () => {
                      handleCreate();
                    }}
                  >
                    Save
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    marginTop: theme.spacing(1)
  },
  saveWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1)
  }
}));
